import { JSEncrypt } from "jsencrypt";

const CryptoJS = require("crypto-js");

const PUBLIC_KEY =
  "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAm6Bz2BcJKurfF6fNvhO5Jnu5l3QFBNPvvQ1dZUkp1gGI4+zlG19l/i1m6HMgtCI7NZpI6esgJAQHctd0u+6BJwY1G0sy2pAMITiRyT7BoJAHg5CrPR9fIwS7KUeMYwOV46vni4QnP8AUB1j+U9bpjFKs11HfE0ZrseECB8T5yrPtFqUX6ebobx6w6PVGf/7hmPcRDitJ8cjvsZRBPzTiB6iN1gARbTWnZbt6LEM9kAYpwU2BcXw89mw+7PhX99TzUq92zApc5/eO1sFBQ0FJVabZ629FXMjkFsm2jopW7eFjUHMSHFSRACNuCpVw8LZtwqWGKE4TVBajF0My+W+ThwIDAQAB";

function Encryption(input, datakey, pg) {
  let encrypted = "";

  // For PayU
  if (pg === 10) {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(PUBLIC_KEY);
    encrypted = encrypt.encrypt(input);
  } else {
    let key = CryptoJS.enc.Utf8.parse(datakey.substring(16, datakey.length));
    let iv = CryptoJS.enc.Utf8.parse(datakey.substring(0, 16));

    let parsedMessageToEncrypt = CryptoJS.enc.Utf8.parse(input);
    encrypted = CryptoJS.AES.encrypt(parsedMessageToEncrypt, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
  }
  // console.log(input, decryption(encrypted.toString()));
  return encrypted.toString();
}

export default Encryption;
